<template>
  <div
    style="
    width: 100%;
    height: 100%;
    break-before:always;
    break-inside:avoid;
    margin: 0;
    padding: 3mm;
    page-break-after: always;"
  >
    <tiss-box
      title="GUIA DE HONORÁRIO INDIVIDUAL"
      :guiaPrestador="numeroGuia"
      :logo="logoURL"
      :operadora="logoText"
      v-if="spsadt != null"
    >
      <div class="row mx-1" style="margin-bottom: 2px;">
        <tiss-field
          title="1 - Registro ANS"
          largura="20%"
          :value="registroANS"
        />
        <tiss-field
          title="3 - Nª Guia de Solicitação de Internação"
          largura="20%"
          :value="guiaSolicInternacao"
        />
        <tiss-field title="4 - Senha" largura="30%" :value="senhaSolicitacao" />
        <tiss-field
          title="5 - Número da Guia Atribuído pela Operadora"
          largura="25%"
          :value="numeroGuiaOperadora"
        />
      </div>

      <!-- Dados do Beneficiário -->
      <div class="row">
        <div class="col">
          <tiss-sub-title title="Dados do Beneficiário"></tiss-sub-title>
        </div>
      </div>

      <div class="row mx-1" style="margin-bottom: 2px;">
        <tiss-field
          title="6 - Número da Carteira"
          largura="17.6%"
          :value="numeroCarteira"
        ></tiss-field>
        <tiss-field
          title="41 - Nome Social"
          largura="30%"
          :value="nomeSocialBeneficiario"
        ></tiss-field>
        <tiss-field
          title="7 - Nome"
          largura="32.2%"
          :value="nomeBeneficiario"
        ></tiss-field>
        <tiss-field
          title="8 - Atendimento a RN"
          largura="15%"
          :value="atendimentoRN"
        ></tiss-field>
      </div>

      <div class="row">
        <div class="col">
          <tiss-sub-title
            title="Dados do Contratado (onde foi executado o procedimento)"
          ></tiss-sub-title>
        </div>
      </div>

      <div class="row mx-1" style="margin-bottom: 2px;">
        <tiss-field
          title="9 - Código na Operadora / CNPJ / CPF"
          largura="20.6%"
          :value="codigoNaOperadora"
        ></tiss-field>
        <tiss-field
          title="10 - Nome Contratado"
          largura="60%"
          :value="nomeContratado"
        ></tiss-field>
        <tiss-field
          title="11 - Código CNES"
          largura="15%"
          :value="cnes"
        ></tiss-field>
      </div>

      <div class="row">
        <div class="col">
          <tiss-sub-title
            title="Dados do Contratado Executante"
          ></tiss-sub-title>
        </div>
      </div>

      <div class="row mx-1" style="margin-bottom: 2px;">
        <tiss-field
          title="12 - Código na Operadora / CNPJ / CPF"
          largura="20.6%"
          :value="codigonaOperadoraExecutante"
        ></tiss-field>
        <tiss-field
          title="13 - Nome Contratado"
          largura="60%"
          :value="nomeContratadoExecutante"
        ></tiss-field>
        <tiss-field
          title="14 - Código CNES"
          largura="15%"
          :value="cnesContratadoExecutante"
        ></tiss-field>
      </div>

      <div class="row">
        <div class="col">
          <tiss-sub-title
            title="Dados da Internação"
          ></tiss-sub-title>
        </div>
      </div>

      <div class="row mx-1" style="margin-bottom: 2px;">
        <tiss-field
          title="15 - Data Início do Faturamento"
          largura="15%"
          :value="dataInicioFaturamento"
        ></tiss-field>
        <tiss-field
          title="16 - Data Fim do Faturamento"
          largura="15%"
          :value="dataFimFaturamento"
        ></tiss-field>
      </div>

      <div class="row">
        <div class="col">
          <tiss-sub-title title="Procedimentos Realizados"></tiss-sub-title>
        </div>
      </div>
      <div class="row mx-1" style="margin-bottom: 2px;">
        <tiss-table
          largura="97%"
          altura="2.5cm"
          :campos="tabelaProcedimentosRealizados"
          :numeracao="Number('17')"
          :sizeCampos="[4, 4, 4, 4, 8, 13, 4, 2, 2, 4, 5, 4]"
          :indice="true"
        />
      </div>


      <div class="row">
        <div class="col">
          <tiss-sub-title title="Identificação do(s) Profissional(is) Executante(s)"></tiss-sub-title>
        </div>
      </div>
      <div class="row mx-1" style="margin-bottom: 2px;">
        <tiss-table
          largura="97%"
          altura="1.9cm"
          :campos="tabelaProfissionaisExecutantes"
          :numeracao="Number('29')"
          :sizeCampos="[3, 3, 4, 15, 4, 4, 4, 4]"
          :indice="false"
        />
      </div>

      <!-- Total Honorários -->
      <div class="row mx-1" style="margin-bottom: 2px;">
        <tiss-field title="" largura="86.3%" style="border-style: none;" />
        <tiss-field
          title="38 - Total Geral"
          largura="10%"
          :value="valorGeral"
        />
      </div>

      <div class="row mx-1" style="margin-bottom: 2px;">
        <tiss-field
          title="37 - Observação/Justificativa"
          largura="97%"
          altura="1.8cm"
          :obrigatorio="false"
           :value="observacao"
        />
      </div>

      <div class="row mx-1 mb-0">
        <tiss-field
          title="39 - Data de Emissão"
          largura="20%"
          :value="dataEmissaoGuia"
        ></tiss-field>
        <tiss-field
          title="40 - Assinatura do Profissional Executante"
          largura="40%"
        ></tiss-field>
      </div>
      <div class="row">
        <div class="col">
          <tiss-rodape
            :infoId="this.guia.id_atendimento"
            :idExterno="this.guia.st_id_externo"
            :responsavel="atendimento_usuario()"
            :pageIndex="pageIndex"
            :pageCount="pageCount"
          ></tiss-rodape>
        </div>
      </div>
    </tiss-box>
  </div>
</template>

<script>
import * as moment from "moment";
import TissTable from "./TissTable.vue";
import TissBox from "./TissBox.vue";
import TissField from "./TissField.vue";
import TissSubTitle from "./TissSubTitle.vue";
import TissRodape from "./TissRodape";
// import TissAssinaturas from "./TissAssinaturas.vue";

export default {
  data() {
    return {
      largura: "21cm",
      larguramm: 200
    };
  },
  methods: {
    clargura(perc = 100) {
      let larg = this.larguramm - 20;
      larg = Math.round(larg * (perc / 100));
      return larg + "mm";
    },
    atendimento_usuario() {
      if (this.guia && this.guia.st_login) {
        return this.guia.st_login;
      }

      return null;
    },
    ocultar_valores() {
        return this.guia && this.guia.ocultar_valores;
    }
  },
  computed: {
    spsadt: function() {
      if (this.guia != null && this.guia.mensagemTISS != null) {
        return this.guia.mensagemTISS;
      }
      return null;
    },
    logoURL: function() {
      if (this.guia && this.guia.logo_url_front) {
        return this.guia.logo_url_front;
      }

      if (this.guia && this.guia.logo_text_front) {
        return null;
      }

      return this.logo
    },
    logoText: function() {
      if (this.guia && this.guia.logo_text_front) {
        return this.guia.logo_text_front;
      }

      return this.operadora ? this.operadora.search : '';
    },
    procedimentos: function() {
      let array = [];
      if (
        !Array.isArray(
          this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
            "guiaHonorarios"
          ].procedimentosRealizados.procedimentoRealizado
        )
      ) {
        array[0] = this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
          "guiaHonorarios"
        ].procedimentosRealizados.procedimentoRealizado;
      } else
        array = this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
          "guiaHonorarios"
        ].procedimentosRealizados.procedimentoRealizado;
      return array;
    },
    profissionalExecutante: function() {
      return this.procedimentos[0].profissionais;
    },
    numeroGuia: function() {
      if (
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaHonorarios"]
          .cabecalhoGuia &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaHonorarios"]
          .cabecalhoGuia.numeroGuiaPrestador
      )
        return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
          "guiaHonorarios"
        ].cabecalhoGuia.numeroGuiaPrestador;
      else return "";
    },
    registroANS: function() {
      if (
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaHonorarios"]
          .cabecalhoGuia &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaHonorarios"]
          .cabecalhoGuia.registroANS
      )
        return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
          "guiaHonorarios"
        ].cabecalhoGuia.registroANS;
      else return "";
    },
    guiaSolicInternacao: function() {
      if (
        !Array.isArray(
          this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
            "guiaHonorarios"
          ].guiaSolicInternacao
        ) &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaHonorarios"]
          .guiaSolicInternacao
      ) {
        return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
          "guiaHonorarios"
        ].guiaSolicInternacao;
      } else return "";
    },
    numeroGuiaOperadora: function() {
      if (
        !Array.isArray(
          this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
            "guiaHonorarios"
          ].numeroGuiaOperadora
        ) &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaHonorarios"]
          .numeroGuiaOperadora
      ) {
        return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
          "guiaHonorarios"
        ].numeroGuiaOperadora;
      } else return "";
    },
    senhaSolicitacao: function() {
      if (
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaHonorarios"]
          .senha
      )
        return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
          "guiaHonorarios"
        ].senha;
      else return "";
    },
    dataEmissaoGuia: function() {
      if (
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaHonorarios"]
          .dataEmissaoGuia
      )
        return this.$util.getFormatDate(
          this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
            "guiaHonorarios"
          ].dataEmissaoGuia
        );
      else return "";
    },
    dataInicioFaturamento: function() {
      if (
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaHonorarios"]
          .dadosInternacao &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaHonorarios"]
          .dadosInternacao.dataInicioFaturamento
      )
        return this.$util.getFormatDate(
          this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
            "guiaHonorarios"
          ].dadosInternacao.dataInicioFaturamento
        );
      else return "";
    },
    dataFimFaturamento: function() {
      if (
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaHonorarios"]
          .dadosInternacao &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaHonorarios"]
          .dadosInternacao.dataFimFaturamento
      )
        return this.$util.getFormatDate(
          this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
            "guiaHonorarios"
          ].dadosInternacao.dataFimFaturamento
        );
      else return "";
    },

    numeroCarteira: function() {
      if (
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaHonorarios"]
          .beneficiario &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaHonorarios"]
          .beneficiario.numeroCarteira
      )
        return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
          "guiaHonorarios"
        ].beneficiario.numeroCarteira;
      else return "";
    },
    nomeBeneficiario: function() {
      if (
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaHonorarios"]
          .beneficiario &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaHonorarios"]
          .beneficiario.nomeBeneficiario
      )
        return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
          "guiaHonorarios"
        ].beneficiario.nomeBeneficiario;
      else return "";
    },
    nomeSocialBeneficiario: function() {
      if (
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaHonorarios"]
          .beneficiario &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaHonorarios"]
          .beneficiario.nomeSocialBeneficiario &&
        !Array.isArray( this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaHonorarios"]
          .beneficiario.nomeSocialBeneficiario)
      )
        return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
          "guiaHonorarios"
        ].beneficiario.nomeSocialBeneficiario;
      else return "";
    },
    atendimentoRN: function() {
      if (
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaHonorarios"]
          .beneficiario &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaHonorarios"]
          .beneficiario.atendimentoRN
      )
        return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
          "guiaHonorarios"
        ].beneficiario.atendimentoRN;
      else return "";
    },
    codigoNaOperadora: function() {
      if (
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaHonorarios"]
          .localContratado &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaHonorarios"]
          .localContratado.codigoContratado &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaHonorarios"]
          .localContratado.codigoContratado.codigoNaOperadora
      )
        return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
          "guiaHonorarios"
        ].localContratado.codigoContratado.codigoNaOperadora;
      else if (
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaHonorarios"]
          .localContratado &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaHonorarios"]
          .localContratado.codigoContratado &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaHonorarios"]
          .localContratado.codigoContratado.cnpjLocalExecutante
      )
        return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
          "guiaHonorarios"
        ].localContratado.codigoContratado.cnpjLocalExecutante;
      else return "";
    },
    nomeContratado: function() {
      if (
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaHonorarios"]
          .localContratado &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaHonorarios"]
          .localContratado.nomeContratado
      )
        return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
          "guiaHonorarios"
        ].localContratado.nomeContratado;
      else return "";
    },
    cnes: function() {
      if (
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaHonorarios"]
          .localContratado &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaHonorarios"]
          .localContratado.cnes &&
        !Array.isArray(this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaHonorarios"]
          .localContratado.cnes)
      )
        return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
          "guiaHonorarios"
        ].localContratado.cnes;
      else return "";
    },
    codigonaOperadoraExecutante: function() {
      if (
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaHonorarios"]
          .dadosContratadoExecutante &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaHonorarios"]
          .dadosContratadoExecutante.codigonaOperadora
      )
        return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
          "guiaHonorarios"
        ].dadosContratadoExecutante.codigonaOperadora;
      else return "";
    },
    nomeContratadoExecutante: function() {
      if (
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaHonorarios"]
          .dadosContratadoExecutante &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaHonorarios"]
          .dadosContratadoExecutante.nomeContratadoExecutante
      )
        return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
          "guiaHonorarios"
        ].dadosContratadoExecutante.nomeContratadoExecutante;
      else return "";
    },
    cnesContratadoExecutante: function() {
      if (
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaHonorarios"]
          .dadosContratadoExecutante &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaHonorarios"]
          .dadosContratadoExecutante.cnesContratadoExecutante
      )
        return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
          "guiaHonorarios"
        ].dadosContratadoExecutante.cnesContratadoExecutante;
      else return "";
    },
    tabelaProcedimentosRealizados: function() {
      let campos = [];

      let procedimentos = this.procedimentos;
      for (let i = 0; i < procedimentos.length; i++) {
        let tmp = {};

        if (procedimentos[i].dataExecucao) {
          tmp["Data"] = this.$util.getFormatDate(
            procedimentos[i].dataExecucao,
            "DD/MM/YYYY"
          );
        } else tmp["Data"] = "";

        if (procedimentos[i].horaInicial)
          tmp["Hora Inicial"] = moment(
            procedimentos[i].horaInicial,
            "HH:mm:ss"
          ).format("HH:mm");
        else tmp["Hora Inicial"] = "";

        if (procedimentos[i].horaFinal)
          tmp["Hora Final"] = moment(
            procedimentos[i].horaFinal,
            "HH:mm:ss"
          ).format("HH:mm");
        else tmp["Hora Final"] = "";

        if (
          procedimentos[i].procedimento &&
          procedimentos[i].procedimento.codigoTabela
        )
          tmp["Tabela"] = procedimentos[i].procedimento.codigoTabela;
        else tmp["Tabela"] = "";

        if (procedimentos[i].procedimento.codigoProcedimento)
          tmp["Codigo do Procedimento"] =
            procedimentos[i].procedimento.codigoProcedimento;
        else tmp["Codigo do Procedimento"] = "";

        if (
          procedimentos[i].procedimento &&
          procedimentos[i].procedimento.descricaoProcedimento
        )
          tmp["Descrição"] =
            procedimentos[i].procedimento.descricaoProcedimento;
        else tmp["Descrição"] = "";

        if (procedimentos[i] && procedimentos[i].quantidadeExecutada)
          tmp["Quantidade"] = procedimentos[i].quantidadeExecutada;
        else tmp["Quantidade"] = "";

        if (procedimentos[i].viaAcesso) tmp["Via"] = procedimentos[i].viaAcesso;
        else tmp["Via"] = "";

        if (procedimentos[i].tecnicaUtilizada)
          tmp["Tec."] = procedimentos[i].tecnicaUtilizada;
        else tmp["Tec."] = "";

        // if (procedimentos[i].reducaoAcrescimo && procedimentos[i].reducaoAcrescimo != "1.00")
        if (procedimentos[i].reducaoAcrescimo)
          tmp["%Red./Acresc."] = this.$util.formatMoeda(
            procedimentos[i].reducaoAcrescimo
          );
        else tmp["%Red./Acresc."] = "";

        if (procedimentos[i].valorUnitario)
          tmp["Valor Unitario"] = !this.ocultar_valores() ? this.$util.formatMoeda(
            procedimentos[i].valorUnitario
          ) : "";
        else tmp["Valor Unitario"] = "";

        if (procedimentos[i].valorTotal)
          tmp["Valor Total"] = !this.ocultar_valores() ? this.$util.formatMoeda(
            procedimentos[i].valorTotal
          ) : "";
        else tmp["Valor Total"] = "";

        campos.push(tmp);
      }

      return campos;
    },
    tabelaProfissionaisExecutantes: function() {
      let campos = [];

      let procedimentos = this.procedimentos;
      for (let i = 0; i < procedimentos.length; i++) {
        let tmp = {};

        tmp["Seq/Ref"] = i + 1;


        if (procedimentos[i].profissionais) {
          tmp["Grau Par"] = procedimentos[i].profissionais.grauParticipacao
        } else tmp["Grau Par"] = "";

        if (procedimentos[i].profissionais && procedimentos[i].profissionais.codProfissional && procedimentos[i].profissionais.codProfissional.cpfContratado)
          tmp["Código na Operadora/CPF"] = procedimentos[i].profissionais.codProfissional.cpfContratado
        else tmp["Código na Operadora/CPF"] = "";

        if (procedimentos[i].profissionais && procedimentos[i].profissionais.nomeProfissional)
          tmp["Nome do Profissional"] = procedimentos[i].profissionais.nomeProfissional
        else tmp["Nome do Profissional"] = "";

        if (procedimentos[i].profissionais && procedimentos[i].profissionais.conselhoProfissional)
          tmp["Conselho Profissional"] = procedimentos[i].profissionais.conselhoProfissional
        else tmp["Conselho Profissional"] = "";

        if (procedimentos[i].profissionais && procedimentos[i].profissionais.numeroConselhoProfissional)
          tmp["Número no Conselho"] =
            procedimentos[i].profissionais.numeroConselhoProfissional;
        else tmp["Número no Conselho"] = "";

        if (procedimentos[i].profissionais &&  procedimentos[i].profissionais.UF)
          tmp["UF"] =
            procedimentos[i].profissionais.UF;
        else tmp["UF"] = "";

        if (procedimentos[i].profissionais &&  procedimentos[i].profissionais.CBO)
          tmp["Código CBO"] =
            procedimentos[i].profissionais.CBO;
        else tmp["Código CBO"] = "";

        campos.push(tmp);
      }

      return campos;
    },
    valorGeral: function() {
      return !this.ocultar_valores() && this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
        "guiaHonorarios"
      ].valorTotalHonorarios
        ? this.$util.formatMoeda(
            this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS[
              "guiaHonorarios"
            ].valorTotalHonorarios
          )
        : "";
    },

     observacao: function() {
      return this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaHonorarios"] &&
        this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaHonorarios"]
          .observacao
        ? this.spsadt.prestadorParaOperadora.loteGuias.guiasTISS["guiaHonorarios"]
            .observacao
        : "";
    },

    styleRotate() {
      if (this.rotate)
        return "transform: rotate(270deg) translate(-376mm, 0); transform-origin: 0 0; margin: 0; padding: 0;";
      //return "-webkit-transform: rotate(-90deg) !important;-moz-transform:rotate(-90deg) !important;-o-transform: rotate(-90deg) !important; -ms-transform:rotate(-90deg) !important;position:relative;top:15cm;left:0px; padding:1cm;";
      //return "-webkit-transform: rotate(-90deg) scale(.65,.65) !important;-moz-transform:rotate(-90deg) scale(.58,.58)!important;-o-transform: rotate(-90deg) scale(.58,.58)!important; -ms-transform:rotate(-90deg) scale(.6,.6)!important;position:relative;top:10cm;left:0px; padding:1cm;";
      return "";
    }
  },
  props: ["guia", "operadora", "logo", "rotate", "pageIndex", "pageCount"],
  components: {
    TissBox,
    TissTable,
    TissField,
    TissSubTitle,
    TissRodape
  }
};
</script>

<style></style>